/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type mutationsDeleteSubscriptionMutationVariables = {
    subscriptionID: string;
};
export type mutationsDeleteSubscriptionMutationResponse = {
    readonly deleteSubscription: boolean;
};
export type mutationsDeleteSubscriptionMutation = {
    readonly response: mutationsDeleteSubscriptionMutationResponse;
    readonly variables: mutationsDeleteSubscriptionMutationVariables;
};



/*
mutation mutationsDeleteSubscriptionMutation(
  $subscriptionID: ID!
) {
  deleteSubscription(input: {subscriptionID: $subscriptionID})
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subscriptionID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "subscriptionID",
            "variableName": "subscriptionID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteSubscription",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsDeleteSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsDeleteSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a7936af873ea8eadfc5b297b004d2d7",
    "id": null,
    "metadata": {},
    "name": "mutationsDeleteSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsDeleteSubscriptionMutation(\n  $subscriptionID: ID!\n) {\n  deleteSubscription(input: {subscriptionID: $subscriptionID})\n}\n"
  }
};
})();
(node as any).hash = 'ac7d44bbfd672a313f4c673657272b8c';
export default node;
